import { select, Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { combineLatest, Observable } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { I18nService } from './i18n.service'
import { LanguageService } from './language.service'
import {
  FetchAvaliableLanguagesRequest,
  FetchDefaultTranslationsRequest,
} from './store/i18n.actions'
import { Language } from './store/i18n.interface'
import {
  getAvaliableLanguagesState,
  getDefaultTranslationsState,
} from './store/i18n.selector'

export const i18nInitialaizer = (
  store: Store<Observable<any>>,
  i18nService: I18nService,
  translateService: TranslateService,
  languageService: LanguageService,
) => {
  return () => {
    store.dispatch(new FetchDefaultTranslationsRequest())
    store.dispatch(new FetchAvaliableLanguagesRequest())

    return new Promise((resolve, reject) => {
      const defaultTranslations$ = store.pipe(
        select(getDefaultTranslationsState),
        filter((state) => Boolean(state)),
        map((state) => state.toJS()),
      )

      const userDefaultLanguage$ = store.pipe(
        select(getAvaliableLanguagesState),
        filter((state) => Boolean(state)),
        map((state) => state.toJS()),
        switchMap((languages: Array<Language>) => {
          let currentLang
          const languageFromCookie = languageService.detectLanguage()
          if (languageFromCookie) {
            currentLang = languages.find(
              (_lang) => _lang.iso2code === languageFromCookie,
            )
          }
          if (!currentLang) {
            currentLang = languages.find((_lang) => _lang.isDefault)
          }

          translateService.addLangs(languages.map((_lang) => _lang.iso2code))
          languageService.activateLanguage(currentLang)
          return translateService.onLangChange.pipe(take(1))
        }),
      )

      combineLatest(defaultTranslations$, userDefaultLanguage$).subscribe(
        (a) => {
          resolve(true)
        },
      )
    })
  }
}
